// Match the PostHog client's existing source/dist singleton behavior.
const registryKey = Symbol.for('borradh.observability.organizationProfiles');
const registry = globalThis;
registry[registryKey] ??= new WeakSet();
const approved = registry[registryKey];
const REDACTED = '[REDACTED]';
const contact = /@|%40|Bearer\s|https?:\/\/|\+?\d[\d\s().-]{6,}\d/i;
export function createOrganizationProfile(organizationId, properties) {
    const result = {
        id: /^(?:[a-z][a-z0-9_-]{0,199}|[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12})$/i.test(organizationId)
            ? organizationId
            : REDACTED,
    };
    if (typeof properties.name === 'string') {
        const name = properties.name;
        result.name =
            name.trim().length > 0 &&
                name.length <= 200 &&
                !contact.test(name) &&
                !Array.from(name).some((character) => character.charCodeAt(0) < 32)
                ? name
                : REDACTED;
    }
    if (typeof properties.slug === 'string') {
        result.slug = /^(?=.*[a-z])[a-z0-9-]{1,200}$/.test(properties.slug)
            ? properties.slug
            : REDACTED;
    }
    if (typeof properties.createdAt === 'string') {
        result.createdAt =
            /^\d{4}-\d{2}-\d{2}T[\d:.]+Z$/.test(properties.createdAt) &&
                Number.isFinite(Date.parse(properties.createdAt))
                ? properties.createdAt
                : REDACTED;
    }
    if (typeof properties.isMock === 'boolean')
        result.isMock = properties.isMock;
    if (typeof properties.plan === 'string') {
        result.plan = /^[a-z0-9][a-z0-9_-]{0,199}$/i.test(properties.plan)
            ? properties.plan
            : REDACTED;
    }
    for (const key of ['businessType', 'subscriptionStatus']) {
        const value = properties[key];
        if (typeof value === 'string')
            result[key] = /^[a-z][a-z0-9_-]{0,99}$/i.test(value) ? value : REDACTED;
    }
    const frozen = Object.freeze(result);
    approved.add(frozen);
    return frozen;
}
export function copyOrganizationProfile(value) {
    if (!approved.has(value))
        return undefined;
    const copy = Object.freeze({ ...value });
    approved.add(copy);
    return copy;
}
//# sourceMappingURL=organization-profile.js.map